import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { BankAccountCombinedResult } from '../../Models/Domains/BankAccount/BankAccountCombinedResult';
import { BankAccountCheckRequest } from '../../Models/Domains/BankAccount/BankAccountCheckRequest';

declare var IS_RUNNING_IN_APP_POOL;

export class ExperianBankWizardRequestClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(request: Array<BankAccountCheckRequest>): Promise<Array<BankAccountCombinedResult>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/BankAccount/ExperianBankWizardRequest/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { request: request }

    return AjaxWrapper.post<Array<BankAccountCombinedResult>, any>(url, data);
  }
}

